import '../scss/product.scss';
import { mountSlider } from '../components/product-slider';
import { $Q } from '../utils/query-selector';
//import { readMore } from "../components/productDescription";
import { getProducts } from '../components/product-recommendations';
import { productQuantitySelector } from '../utils/product-input-quantity';
import {
  initRelatedProductsSlider,
  handleCheckProduct,
  handleSelectProduct,
} from '../components/related-products';

// register the functions globally since they are being accessed
// through "onchange" "on[event]" handlers, which will make refactoring
// more dificult and error prone than just exposing the functions globally
window.handleCheckProduct = handleCheckProduct;
window.handleSelectProduct = handleSelectProduct;

const productDetail = $Q('.main-product__detail');

const productSlider = mountSlider($Q('.swiper.main-product__slider-principal'));
//readMore();
getProducts();
productQuantitySelector(productDetail);

const scrollToReviews = () => {
  addEventListener('DOMContentLoaded', () => {
    const reviewsCarousel = $Q('.reviews-carousel');
    onscroll = function () {
      if (
        reviewsCarousel.getBoundingClientRect().top >= 0 &&
        reviewsCarousel.getBoundingClientRect().top < 1
      ) {
        scrollTo(0, scrollY - 160);
      }
    };
    document.addEventListener('touchmove', () => {
      if (
        reviewsCarousel.getBoundingClientRect().top >= 0 &&
        reviewsCarousel.getBoundingClientRect().top < 1
      ) {
        scrollTo(0, scrollY - 160);
      }
    });
  });
};

const handleFormDefective = () => {
  const changeSlide = (defective = false) => {
    const slide = $Q('.defective-slide__photo');
    if (!slide && defective) return;

    const n = defective ? Number(slide.dataset.index) : 0;
    if (n !== productSlider.activeIndex) productSlider.slideTo(n);
  };

  const searchParams = new URLSearchParams(location.search);
  if (searchParams.has('defective')) {
    $Q('input[name="propertie_defective"][value=true]').checked = true;
    changeSlide(true);
  }

  $Q('.main-product__variants').addEventListener('change', (e) => {
    const isChecked = $Q(
      'input[name="propertie_defective"][value=true]'
    )?.checked;
    if (isChecked) {
      if (e.target.closest('#defective-form')) {
        changeSlide(isChecked);
      } else if (e.target.closest('.variants') && isChecked) changeSlide();
    }
  });
};

handleFormDefective();
scrollToReviews();

const observer = new MutationObserver(() => {
  const firstItem = document.querySelector('.related-products__item');
  if (firstItem) {
    initRelatedProductsSlider();
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });
